export function setInvitations (state, invitations) {
	state.invitations = [ ...invitations ];
}
